import { render, staticRenderFns } from "./ListCustomerCareForm.vue?vue&type=template&id=6ea8d3c6"
import script from "./ListCustomerCareForm.vue?vue&type=script&lang=js"
export * from "./ListCustomerCareForm.vue?vue&type=script&lang=js"
import style0 from "./ListCustomerCareForm.vue?vue&type=style&index=0&id=6ea8d3c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports